import { AxiosPromise, AxiosResponse } from 'axios';
import { AnyAction, Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { ServerResponse } from 'data/types';
import { AsyncAction } from 'redux-promise-middleware';

export const API_PATH_BACKUP_RESTORE = '/backups';
export const API_PATH_BACKUP_TASKS = '/jobs';

export const FETCH_BACKUP_TASKS = 'FETCH_BACKUP_TASKS';
export const FETCH_BACKUP_TASKS_FULFILLED = 'FETCH_BACKUP_TASKS_FULFILLED';

export const REQUEST_BACKUP_FILE = 'REQUEST_BACKUP_FILE';
export const REQUEST_BACKUP_FILE_FULFILLED = 'REQUEST_BACKUP_FILE_FULFILLED';

export const DELETE_BACKUP = 'DELETE_BACKUP';
export const DELETE_BACKUP_FULFILLED = 'DELETE_BACKUP_FULFILLED';

export const DELETE_JOB = 'DELETE_JOB';
export const DELETE_JOB_FULFILLED = 'DELETE_JOB_FULFILLED';

export const RESTORE_BACKUP_FILE = 'RESTORE_BACKUP_FILE';
export const RESTORE_BACKUP_FILE_FULFILLED = 'RESTORE_BACKUP_FILE_FULFILLED';

export const GO_TO_BACKUP_CREATE = 'GO_TO_BACKUP_CREATE';
export const GO_TO_BACKUP_LIST = 'GO_TO_BACKUP_LIST';

export interface BackupCauseDTO {
  message: string | null;
  reason: string | null;
  type: string;
}

export interface BackupFileDTO {
  filename: string;
  createdOn: Date | null;
  product: string;
}

export interface BackupJobDTO {
  name: string;
  id: string;
  type: string;
  start_time: Date | null;
  completion_time: Date | null;
  status: string;
  product: string | null;
  cause: BackupCauseDTO;
  env?: EnvVariable[];
}
export interface EnvVariable {
  name: string;
  value: string;
  value_from?: string;
}
export interface BackupJobListDTO {
  product: string;
  jobs: BackupJobDTO[];
}

export interface BackupJobListResponseDTO {
  xcipioJobList: BackupJobDTO[];
  dxJobList: BackupJobDTO[];
  xcipioBackupFilesList: BackupFileDTO[];
  dxBackupFilesList: BackupFileDTO[];
  xcipioErrorMessage: string | null;
  dxErrorMessage: string | null;
}

export interface BackupRequestDTO {
  FILENAME?: string;
  CREATE_DATABASE?: string;
  owner: string;
  product: string;
}

export interface RestoreRequestDTO {
  FILENAME: string;
  owner: string;
  product: string;
}

export interface FetchAllBackupTasksAction extends AsyncAction {
  type: typeof FETCH_BACKUP_TASKS;
  payload: AxiosPromise<ServerResponse<BackupJobListResponseDTO>>;
}

export interface FetchAllBackupTasksFulfilledAction extends Action {
  type: typeof FETCH_BACKUP_TASKS_FULFILLED;
  payload: AxiosResponse<BackupJobListResponseDTO>;
}

export interface DeleteBackupFileAction extends AsyncAction {
  type: typeof DELETE_BACKUP;
  payload: AxiosPromise<ServerResponse<BackupFileDTO>>;
}

export interface DeleteBackupFileFulfilledAction extends Action {
  type: typeof DELETE_BACKUP_FULFILLED;
  payload: AxiosResponse<ServerResponse<BackupFileDTO>>;
}

export interface DeleteBackupFileThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteJobAction extends AsyncAction {
  type: typeof DELETE_JOB;
  payload: AxiosPromise<ServerResponse<void>>;
}

export interface DeleteJobFulfilledAction extends Action {
  type: typeof DELETE_JOB_FULFILLED;
  payload: AxiosResponse<ServerResponse<void>>;
}

export interface DeleteBackupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface RequestBackupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface RequestBackupAction extends AsyncAction {
  type: typeof REQUEST_BACKUP_FILE;
  payload: AxiosPromise<ServerResponse<void>>;
}

export interface RequestBackupFulfilledAction extends Action {
  type: typeof REQUEST_BACKUP_FILE_FULFILLED;
  payload: AxiosResponse<BackupJobListResponseDTO>;
}

export interface RestoreBackupFileAction extends AsyncAction {
  type: typeof RESTORE_BACKUP_FILE;
  payload: AxiosPromise<ServerResponse<void>>;
}

export interface RestoreBackupFileFulfilledAction extends Action {
  type: typeof RESTORE_BACKUP_FILE_FULFILLED;
  payload: AxiosResponse<BackupJobDTO>;
}

export interface RestoreBackupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface BackupRestoreState {
  backupFiles: BackupFileDTO[];
  tasks: BackupJobListResponseDTO;
  selected?: BackupFileDTO,
}

export type BackupRestoreActionTypes =
  | FetchAllBackupTasksAction
  | FetchAllBackupTasksFulfilledAction
  | DeleteBackupFileAction
  | DeleteBackupFileFulfilledAction
  | DeleteJobAction
  | DeleteJobFulfilledAction
  | RequestBackupAction
  | RequestBackupFulfilledAction
  | RestoreBackupFileAction
  | RestoreBackupFileFulfilledAction;
